import { type PropsWithChildren, useEffect } from 'react';
import { isMobileWeb } from '@toss/utils';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useAlert } from '@/hooks';
import { useUser } from '@/lib/auth';
import { useUserPlanManager } from '@/shared/plan';
import { cn } from '@/utils';
import { Header } from './Header';
import { SideBar } from './SideBar';
const PRO_ONLY_PATHS = ['/learning-report', '/question-stats'];
export const Layout = ({
  children
}: PropsWithChildren) => {
  const {
    t
  } = useTranslation(['common']);
  const router = useRouter();
  const {
    isInitialized,
    user
  } = useUser();
  const alert = useAlert();
  const {
    userPlanManager
  } = useUserPlanManager();
  const isProOnlyPath = PRO_ONLY_PATHS.some(path => router.asPath.includes(path));
  const isBlurry = isProOnlyPath && isInitialized && !userPlanManager.canAccessFeature('LMS_PARTIAL') && !user?.admin;
  const isMobile = isMobileWeb();
  useEffect(() => {
    if (isMobile) {
      void alert({
        type: 'alert',
        title: t('common:pcOnlyAlert')
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobile]);
  return <>
      <Header data-sentry-element="Header" data-sentry-source-file="Layout.tsx" />
      <div className="flex h-screen w-screen pt-[65px]">
        <SideBar data-sentry-element="SideBar" data-sentry-source-file="Layout.tsx" />
        <main className={cn('size-full overflow-auto bg-neutral', isBlurry && 'blur-[4px]')}>
          <div className="flex min-h-full min-w-[773px] flex-col px-3xl pb-3xl pt-2xl">
            <div className="mx-auto flex w-[min(100%,1120px)] grow flex-col gap-xl">
              {children}
            </div>
          </div>
        </main>
      </div>
    </>;
};